import Http from '@/api/request'

/**
 * 用户相关接口
 */
export const UserApi = {
  // 获取用户信息
  getUserInfo () {
    return Http.get('/v2/userinfo')
  },
  // mt数量
  getMyCount (data) {
    return Http.get('/v2/mt_count', data)
  },
  // 获取用户可寄售藏品列表
  loadUserCanSaleList (params) {
    return Http.get(`/market/my/can_sale_list`, params)
  },
}